import { AdminToolWrapperProps } from '..'
import { useTranslationData } from '../../contexts'
import { GET_API_NEWS, GET_LOCALIZED_OPTIONS } from '../../graphql'
import { TranslationDataUpdater } from './translation-data-updater'

type LocalizationsUpdaterProps = Omit<AdminToolWrapperProps, 'children'>

export const LocalizationsUpdater = ({
  useAdminTool,
  useAdminToolNews
}: LocalizationsUpdaterProps) => {
  const { setNewsData, setOptionsLists } = useTranslationData()

  return (
    <>
      <TranslationDataUpdater
        dataUpdateFn={setOptionsLists}
        query={GET_LOCALIZED_OPTIONS}
      />
      {/*  TODO: remove this when admin tool is in use */}
      {useAdminTool && useAdminToolNews && (
        <TranslationDataUpdater
          dataUpdateFn={setNewsData}
          query={GET_API_NEWS}
        />
      )}
    </>
  )
}
